import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["value"]

import { computed } from "vue";

import { useUIContentStore } from "@/stores/ui-content.store";
import { useUIFilesStore } from "@/stores/ui-files.store";
import { useUIGeneralStore } from "@/stores/ui-general.store";


export default /*@__PURE__*/_defineComponent({
  __name: 'ToggleEditMode',
  setup(__props) {

const uiGeneralStore = useUIGeneralStore();
const uiFilesStore = useUIFilesStore();
const uiContentStore = useUIContentStore();

const isContentSidebarWiden = computed<boolean>(() => {
  return (
    !!uiContentStore.sectionToDisplay && uiContentStore.isContentSidebarExpanded
  );
});

const areModalsOpen = computed<boolean>(() => {
  return (
    uiFilesStore.isRenameAttachmentPopupOpen ||
    uiFilesStore.isRemoveAttachmentPopupOpen ||
    uiFilesStore.isFileVersionModalOpen ||
    uiContentStore.isEditContentPathModalOpen
  );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    class: _normalizeClass([
      'toggle-check',
      {
        'right-sidebar-open': _unref(uiGeneralStore).isRightSidebarOpen,
        'content-sidebar-expanded': isContentSidebarWiden.value,
        'modals-open': areModalsOpen.value
      }
    ]),
    "data-testing": "edit-mode"
  }, [
    _createElementVNode("input", {
      type: "checkbox",
      "aria-label": "edit",
      "data-testing": "toggle-edit-mode",
      value: _unref(uiGeneralStore).isEditModeEnabled,
      class: "editable",
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(uiGeneralStore).toggleEditModeEnabled && _unref(uiGeneralStore).toggleEditModeEnabled(...args)))
    }, null, 40, _hoisted_1),
    _cache[1] || (_cache[1] = _createElementVNode("span", {
      "data-off-text": "Edit mode off",
      "data-on-text": "Edit mode on"
    }, null, -1))
  ], 2))
}
}

})